import { render, staticRenderFns } from "./QIUBO_SCM_TEST.vue?vue&type=template&id=81b41b30&scoped=true"
import script from "./QIUBO_SCM_TEST.vue?vue&type=script&lang=js"
export * from "./QIUBO_SCM_TEST.vue?vue&type=script&lang=js"
import style0 from "./QIUBO_SCM_TEST.vue?vue&type=style&index=0&id=81b41b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b41b30",
  null
  
)

export default component.exports